import React , { useState ,useEffect} from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { extendTheme } from "@chakra-ui/react"
import "ag-grid-enterprise";
import axios from 'axios';
import {  BrowserRouter as Router, Switch } from "react-router-dom";

// import { ColorModeSwitcher } from './ColorModeSwitcher';
// import { Logo } from './Logo';

import PrivateRoute from './components/Routes/PrivateRoute';
import PublicRoute from './components/Routes/PublicRoute';
// import Listing from './components/Listing/listing.js';
import Login from './components/Login/login.js';
import LoginSSO from './components/Login/login-sso.js';
import MfaSetup from './components/Login/mfa-setup.js';
import MfaVerify from './components/Login/mfa-verify.js';
import ListCases from './components/Cases/case-list';
import Preference from './components/preference/preference';
import Statistics from './components/statistics/statistics'
import TransactionList from './components/Transaction/TransactionList'
import TransactionView from './components/Transaction/TransactionView'
import ListCasesWeeklyGroup from './components/Cases/ListCasesWeeklyGroup';

import AuthService from './services/auth.service';

import './App.css';

function App() {
  const theme = extendTheme({
    styles: {
      global: {
        // styles for the `body`
        body: {
          margin: 0,
          padding: 0,
          fontSize:"12px"
        }
      }
    }
  })
  // const { isOpen, onOpen, onClose } = useDisclosure();
  
  const [currentUser , setCurrentUser] = useState({});
  // const history = useHistory();
  axios.interceptors.response.use(response => {
    return response;
  }, error => {
  
  if (error.response && error.response.status === 401) {
      AuthService.clearToken();
      //history.push("/login");
      window.location.href = '/login';
  }
  return Promise.reject(error);
  });
  useEffect(()=>{
    const user = AuthService.getCurrentUser();
    if (user && Object.keys(currentUser).length <=0 ) {
        setCurrentUser(user);
    }
  },[currentUser])

  
  return (
    <ChakraProvider theme={theme}>
        <Router>
            <Switch>
                <PublicRoute path="/login"  restricted={true} component={Login} exact />
                <PublicRoute path="/login-shib"  restricted={true} component={LoginSSO} exact />
                <PublicRoute path="/mfa-setup" restricted={false} component={MfaSetup} exact />
                <PublicRoute path="/mfa-verify" restricted={false} component={MfaVerify} exact />
                <PublicRoute path="/" restricted={true} component={Login} exact />
                {/* <PrivateRoute path="/transaction"  component={Listing} exact /> */}
                <PrivateRoute path="/cases" component={ListCases} exact />
                <PrivateRoute path="/preference" component={Preference} />
                <PrivateRoute path="/statistics" component={Statistics} exact />
                {/* <PrivateRoute path="/files" component={MerchantFolderListing} exact /> */}
                <PrivateRoute path="/transaction"  component={TransactionList} exact />
                <PrivateRoute path="/transaction/view" component={TransactionView} exact />
                <PrivateRoute path="/cases-group-by-week" component={ListCasesWeeklyGroup} exact />
            </Switch>
        </Router>
    </ChakraProvider>
  );
}

export default App;
